<template>
    <div class="data-wrapper-core">
        <h3>Kampagnen</h3>
        <div class="content-data-table-wrapper">
            <v-text-field class="content-data-search" flat v-model="search" label="Suche"
                prepend-inner-icon="mdi-magnify" variant="outlined" density="compact" hide-details single-line
                rounded="lg"></v-text-field>
            <v-data-table class="content-data-table" density="compact" :headers="headers" :items="tables"
                :search="search">
                <template v-slot:item="{ item }">
                    <tr class="v-table-row" @click="openTableDialog(item)">
                        <td>{{ item.occupation }}</td>
                        <td>{{ item._id }}</td>
                    </tr>
                </template>
            </v-data-table>
            <TableDialog v-if="selectedTable._id" :tableId="selectedTable._id"></TableDialog>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import TableDialog from '../tableDialog/TableDialog.vue';

export default {
    components: {
        TableDialog
    },
    props: {
        customers: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            search: '',
            headers: [
                { key: 'occupation', title: 'Name', sortable: true },
                { key: '__id', title: 'Table ID', sortable: true },
            ],
            selectedTable: {}
        };
    },
    computed: {
        ...mapState('customer', ['tables'])
    },
    methods: {
        ...mapMutations('customer', ['resetCustomer']),
        openTableDialog(item) {
            this.$store.commit('table/setTableDialog', true);
            this.$store.commit('customer/setCustomerDialog', false);
            this.$store.commit('customer/resetCustomer');
            this.$router.push({ name: 'table', params: { tableId: item._id } });
        }
    }
};
</script>

<style lang="scss" scoped>

.content-data-search {
    margin: 8px 0;
    border-radius: 12px;
}

.content-data-table {
    border: 1px solid rgb(196, 196, 196);
    border-radius: 12px;
}

.v-table {
    background-color: #f9fafb;
}

.v-table-row {
    cursor: pointer;
}

.content-dialog-customer {
    margin: 8px 0;
}
</style>